import FixedHeader from './components/fixedHeader';
import OffCanvasNav from './components/offCanvasNav';
import SiteHeaderSearchToggle from './components/siteHeaderSearchToggle';
import NewsletterModal from './components/newsletterModal';
import CarouselBlock from './components/carouselBlock';
import JPlusSignup from './components/jPlusSignup';
// Disabled for now, can be enabled if we want to load comment count using wp ajax
// import Comments from './components/comments';
import AdTracking from './components/adTracking';
import { datajsAll } from './shared/utils';
import Newsfeed from './components/newsfeed';
import Articles from './components/articles';

document.addEventListener('DOMContentLoaded', () => {
	// Comments.init();
	AdTracking.init();
	Articles.init();
	CarouselBlock.init();
	FixedHeader.init();
	JPlusSignup.init();
	Newsfeed.init();
	NewsletterModal.init();
	OffCanvasNav.init();
	SiteHeaderSearchToggle.init();

	// Hide all but last occurance of news-feed archive button
	let newsArchiveButtons = datajsAll('news-archive-btn').slice(0, -1);
	newsArchiveButtons.forEach((btn) => {
		btn.classList.add('d-none');
	});

	// Remove Iframe and Video loader when ready
	document.addEventListener('lazyloaded', (e) => {
		const closestHasLoaderParent = e.target.closest('.has-loader');

		if (closestHasLoaderParent) {
			closestHasLoaderParent.classList.remove('has-loader');
		}
	});
});
